
// @ts-nocheck


export const localeCodes =  [
  "zh-CN",
  "zh-TW",
  "vi_VN",
  "en",
  "ja_JP"
]

export const localeLoaders = {
  "zh-CN": [],
  "zh-TW": [],
  vi_VN: [],
  en: [],
  ja_JP: []
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/5d15824f" /* webpackChunkName: "config_i18n_46config_46js_5d15824f" */),
  () => import("#nuxt-i18n/5d15824f" /* webpackChunkName: "config_i18n_46config_46js_5d15824f" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: false
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    "zh-CN",
    "zh-TW",
    "vi_VN",
    "en",
    "ja_JP"
  ],
  defaultLocale: "zh-CN",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "no_prefix",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_current_locale",
    cookieSecure: false,
    fallbackLocale: "zh-CN",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    language: "zh-CN",
    code: "zh-CN"
  },
  {
    language: "zh-TW",
    code: "zh-TW"
  },
  {
    language: "vi_VN",
    code: "vi_VN"
  },
  {
    language: "en",
    code: "en"
  },
  {
    language: "ja_JP",
    code: "ja_JP"
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/